module.exports = __webpack_public_path__ + "img/prod-5.ec3d2463.png";